import { Box, Divider, Grid } from '@mui/material';
import CaseInfoItem from 'components/case/CaseInfoItem/CaseInfoItem';
import CPTModifierItem from 'components/case/CPTModifierItem/CPTModifierItem';
import ICDItem from 'components/case/ICDItem/ICDItem';
import CustomText from 'components/common/CustomText/CustomText';
import LabelValueRow from 'components/common/LabelValueRow/LabelValueRow';
import React, { useEffect, useMemo, useState } from 'react'
import { colors } from 'styles/colors';
import useGlobalStyles from 'styles/globalStyles';
import { ICD } from 'types/types';

interface Props {
  cpts: any[];
  cptModifier: any;
}

export default function CPTModifierDetails({ cpts, cptModifier }: Props) {
  const globalStyles = useGlobalStyles();
  const [totalRVUs, setTotalRVUs] = useState<number>(0);
  const [totalReimbursable, setTotalReimbursable] = useState<number>(0);

  const calculateRVUs = () => {
    let maxRvu = 0;
    let sumOfRestOfRvus = 0;
    let sumRvu = cpts.reduce(function (sum: number, item: any) {
      return (sum = sum + (item.cpt_lookup.rvu_value * item.quantity));
    }, 0);
    setTotalRVUs(sumRvu);
    for (let i = 0; i < cpts.length; i++) {
      if (cpts[i].cpt_lookup.rvu_value > maxRvu) {
        maxRvu = cpts[i].cpt_lookup.rvu_value;
      }
    }
    maxRvu = Number(maxRvu);
    sumOfRestOfRvus = sumRvu - maxRvu;
    const sumOfTotalReimbursable = maxRvu + (sumOfRestOfRvus * 0.5);
    setTotalReimbursable(sumOfTotalReimbursable);
  }

  useEffect(() => {
    if (cpts?.length > 0) {
      calculateRVUs();
    }
  }, [cpts])

  const totalRVUsAfterCPTModifier = useMemo(() => {
    if (cptModifier) {
      return (totalReimbursable * cptModifier.percentage / 100)
    }
    return 0;
  }, [cptModifier, cpts, totalReimbursable]);

  return (
    <Box className={globalStyles.sectionContainer}>
      <Box className={globalStyles.sectionHeader}>
        <CustomText
          text="CPT Modifier"
          color={colors.primary}
          fontWeight={600}
        />
      </Box>

      <Divider />

      <Box px={3} mt={2}>
        <LabelValueRow
          label="Total Reimbursable RVUs After CPT Modifier"
          value={totalRVUsAfterCPTModifier.toFixed(3)}
        />
      </Box>

      <Grid container p={3} spacing={1.5}>
        {cptModifier && (
          <Grid
            size={{ xs: 12, md: 6 }}
            key={`${cptModifier.id}`}>
            <CPTModifierItem item={cptModifier} />
          </Grid>
        )}

        {cpts?.length == 0 && (
          <Box>
            <CustomText text={'N/A'} />
          </Box>
        )}
      </Grid>

    </Box>
  )
}
